<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item" v-for="(link, index) in navLinks"
          :key="index"
          v-has-permissions="link.permissions">
          <router-link class="nav-link" :to="link.url">
            <i class="nav-icon" :class="link.icon"></i>
            {{ link.name }}
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { PERMISSIONS } from '../../../permissions';
import navLinks from './links';
export default {
  name: 'DefaultContainer',
  data () {
    return {
      navLinks: navLinks.items,
      PERMISSIONS
    }
  },
}
</script>
